// extracted by mini-css-extract-plugin
module.exports = {"soundIcon":"styles_soundIcon__2Bkvr","soundIndicatorsContainer":"styles_soundIndicatorsContainer__1mnUe"};